module.exports = "/assets/data/f6923165d1b573ae23bd5873ba7ae5e4-NN10.data.json";